import { DocumentIsogd } from "isogd-document-rest";

class DocumentOrganizationViewController {
    private document: DocumentIsogd;
}

export const DocumentOrganizationViewComponent: angular.IComponentOptions = {
    controller: DocumentOrganizationViewController,
    template: require('./documentOrganizationView.html'),
    bindings: {
        document: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-organization/documentOrganizationView.ts